/* Aquaholics campaign LP — theme asset interactions (vanilla JS) */
(function () {
  'use strict';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.aqh-reveal');
    if (!('IntersectionObserver' in window) || prefersReduced) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--aqh-reveal-delay', Math.min(siblings, 6) * 70 + 'ms');
      io.observe(el);
    });
  }

  function initDock() {
    var dock = document.querySelector('.aqh-dock');
    var hero = document.querySelector('.aqh-hero');
    if (!dock || !hero) return;
    var shown = false;
    function onScroll() {
      var past = window.scrollY > hero.offsetHeight - 120;
      if (past && !shown) { dock.classList.add('is-visible'); shown = true; }
      else if (!past && shown) { dock.classList.remove('is-visible'); shown = false; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initFaq() {
    var items = document.querySelectorAll('.aqh-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initDock();
    initFaq();
  });
})();
